import React from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher({ className = '' }) {
  const { t, i18n } = useTranslation();

  return (
    <label className={className} style={{ fontSize: 13, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span style={{ color: '#6b7280' }}>{t('language.label')}</span>
      <select
        value={i18n.language?.startsWith('fr') ? 'fr' : 'en'}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13 }}
      >
        <option value="en">{t('language.en')}</option>
        <option value="fr">{t('language.fr')}</option>
      </select>
    </label>
  );
}

export default LanguageSwitcher;
